import { InspectorPanelSettingsFields } from "../InspectorPanelSettingsFields"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { ButtonPrimary } from "@nova/component-btn"
import { activateSidePanelModal } from "panels/content/side-panel/thunks"
import { clearSelection } from "panels/content/side-panel/slice.new"
import { selectPanoramaFlightById } from "features/entity-caching/flights/selectors"

export const InspectorPanelPanoramaLayer = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const flight = useAppSelector(selectPanoramaFlightById(id))
    if (!flight) return null
    const panoramaExists = flight.images.length > 0

    return (
        <InspectorPanelSettingsFields shouldShowTopBorder={false}>
            {panoramaExists && (
                <ButtonPrimary
                    title="View Panorama"
                    RightIcon={Icons.VRPano}
                    className="mb-2"
                    onClick={() => {
                        dispatch(clearSelection())
                        dispatch(
                            activateSidePanelModal({
                                id,
                                type: "layer",
                                layerContentType: "pano",
                            })
                        )
                    }}
                />
            )}
        </InspectorPanelSettingsFields>
    )
}
